import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-create-tag-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data?.tagName ? 'Rename Tag' : 'Create New Tag' }}</h2>
    <mat-dialog-content>
      <mat-label>Tag Name</mat-label>
      <mat-form-field appearance="fill" class="w-full mt-2">
        <input matInput [(ngModel)]="tagName" placeholder="Enter tag name" autofocus (keyup.enter)="onSave()">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!tagName.trim() || tagName.trim() === data?.tagName" (click)="onSave()">
        {{ data?.tagName ? 'Update' : 'Create' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .w-full { width: 100%; }
    mat-dialog-content { min-width: 300px; }
  `]
})
export class CreateTagDialogComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<CreateTagDialogComponent>);
  public data = inject(MAT_DIALOG_DATA, { optional: true });
  tagName: string = '';

  ngOnInit(): void {
    if (this.data?.tagName) {
      this.tagName = this.data.tagName;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.tagName.trim()) {
      this.dialogRef.close(this.tagName.trim());
    }
  }
}
